import { NgModule } from "@angular/core";
import { RedirectComponent } from "./redirect.component";

@NgModule({
    declarations: [RedirectComponent],
    exports: [RedirectComponent]
})
export class RedirectModule {
}
